import { render, staticRenderFns } from "./DigikalaIntegrator.vue?vue&type=template&id=4fc1a099&scoped=true&"
import script from "./DigikalaIntegrator.vue?vue&type=script&lang=js&"
export * from "./DigikalaIntegrator.vue?vue&type=script&lang=js&"
import style0 from "./DigikalaIntegrator.vue?vue&type=style&index=0&id=4fc1a099&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1a099",
  null
  
)

export default component.exports